<template>
	<div class="itemWrap">
		<div class="itemHead" v-if="index !== 0">
			<div class="itemHeadTitle">Extra stop #{{ index }}</div>
			<div class="contract_btn">
				<button @click="onDeleteItem" type="button" class="mainBtn mainBtn-text">
          <span class="btnIco">
              <svg-sprite icon-id="deleteItem" width="20" height="20"></svg-sprite>
          </span>
				</button>
			</div>
		</div>
		<div class="itemMain">
			<field
					margin="0"
					label="Company"
					placeholder="Enter company name"
					@updateInput="onInput($event, 'company')"
					:setInputValue="item.company"
			></field>
			<field
					margin="0"
					label="Address"
					placeholder="Enter address"
					@updateInput="onInput($event, 'street')"
					:setInputValue="item.street"
			></field>
			<field
					margin="0"
					label="Phone"
					placeholder="Enter phone"
					@updateInput="onInput($event, 'phone')"
					:setInputValue="item.phone"
					is-phone
			></field>
			<field
					margin="0"
					label="Location"
					placeholder="Select location"
					@updateSearchText="onSearchText($event, 'location')"
					@updateAutocomplete="onAutocomplete($event, 'loction')"
					@updateAutocompleteList="onAutocompleteList($event, 'locationSelect')"
					:autocompleteValue="locationSelect"
					:items="locationList"
					:isClearable="false"
					is-autocomplete
					is-required
					is-btn-autocomplete
					:is-loading="isLoading"
					:classError="currentErrors.location"
					textError="⚠️ Please select a valid location."
			></field>
			<field
					margin="0"
					type="text"
					label="Date and time"
					placeholder="MM/DD/YYYY HH:MM"
					:dateValue="item.date_time"
					display-format="YYYY-MM-DD hh:mm"
					@updateTime="onTime($event, 'date_time')"
					is-time
					is-required
					:classError="currentErrors.date_time"
					textError="⚠️ Please enter a valid date and time."
			></field>
			<field
					margin="0"
					label="App#"
					placeholder="Enter app number"
					@updateInput="onInput($event, 'app')"
					:setInputValue="item.app"
					is-number
			></field>
		</div>
	</div>
</template>

<script>
import { PAGE } from "@/constants/constants";
import { mapActions } from "vuex";

export default {
	name: PAGE.TRIP_PICKUP_DELIVERY_ITEM,
	props: {
		item: Object,
		index: Number,
		defaultLocation: Array,
		errors: Object,
	},
	computed: {
		currentErrors() {
			return (this.errors && this.errors[this.index]) || {};
		}
	},
	data() {
		return {
			isLoading: false,
			// company: null,
			// street: null,
			// phone: null,
			locationList: null,
			locationSelect: { id: null, value: null },
			locationListDefault: [],
			locationSelectDefault: null,
			// date_time: null,
			// app: null,
			isSelect: false,
		};
	},
	methods: {
		...mapActions([
			"getLocationTripDialog",
		]),
		onAutocomplete({ value }, key, id) {
			this.$emit('updateAutocomplete', { value, key, id });
		},
		async onAutocompleteList({ text }) {
			const { value } = this.locationSelect;
			if (text !== null && text !== value) {
				const substrings = text.split(', ');
				const modString = substrings[2] ? substrings[2] : text;
				this.isLoading = true;
				const location = await this.getLocationTripDialog({ string: modString });
				this.locationList = this.getModLocation(location);
				this.isLoading = false;
			}
		},

		onInput({ value }, key, parent) {
			this.$emit('updateInput', { value, key, parent });
		},
		onSearchText(name, key) {
			this.$emit('updateSearchText', { name, key });
		},
		onTime(value, key) {
			this[key] = value;
			this.$emit('updateTime', { value, key });
		},
		onDeleteItem() {
			this.$emit('updateDeleteItem');
		},
		getModLocation(location) {
			if (Array.isArray(location)) {
				return location.map(item => {
					const { city, city_id, state, zip_code, state_id } = item;
					return { id: city_id, value: `${ city }, ${ state }, ${ zip_code }`, city, city_id, state, zip_code, state_id };
				});
			} 
			const { city, city_id, state, zip_code, state_id } = location;
			if (city_id) return [ { id: city_id, value: `${ city }, ${ state }, ${ zip_code }`, city, city_id, state, zip_code, state_id } ];
		},
	},
	watch: {
		'item.loction': {
			deep: true,
			handler(loction) {
				if (!loction) return;
				const { city_id } = loction;
				if (city_id == null) {
					this.locationList = this.getModLocation(this.defaultLocation);
					this.locationSelect = { id: null, value: null };
					this.locationListDefault = this.getModLocation(this.defaultLocation);
					this.locationSelectDefault = { id: null, value: null };
				} else {
					this.locationList = this.getModLocation(loction);
					this.locationSelect = this.locationList[0];
					this.locationListDefault = this.getModLocation(loction);
					this.locationSelectDefault = this.locationListDefault[0];
				}
			}
		}
	},

	mounted() {
		if (this.item && this.defaultLocation) {
			// const { app, company, date_time, loction, phone, street } = this.item;
			const { loction } = this.item;
			const { city_id } = loction;
			if (city_id === null) {
				this.locationList = this.getModLocation(this.defaultLocation);
				this.locationSelect = { id: null, value: null };
				this.locationListDefault = this.getModLocation(this.defaultLocation);
				this.locationSelectDefault = { id: null, value: null };
			} else {
				this.locationList = this.getModLocation(loction);
				this.locationSelect = this.locationList[0];
				this.locationListDefault = this.getModLocation(loction);
				this.locationSelectDefault = this.locationListDefault[0];
			}
			// this.company = company;
			// this.street = street;
			// this.phone = phone;
			// this.date_time = date_time;
			// this.app = app;

		}
	}
};
</script>

<style scoped lang="scss">
@import "PickupDeliveryItem";
</style>
